import React, { useState } from 'react';
import { Box, Typography, IconButton, Collapse, Container, List, ListItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import './SeventhSection.scss';


const SeventhSection = ({ title, faqs }) => {
    const [expandedIndex, setExpandedIndex] = useState(null);

    const handleToggle = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    return (
        <Box className="seventh-section">
            <Container>
                <Typography variant="h4" component="h2" className="section-title">
                    {title}
                </Typography>

                {faqs.map((item, index) => (
                    <Box key={index} className="faq-item">
                        <Box className="faq-question" onClick={() => handleToggle(index)}>
                            <Typography variant="h6" component="h3">
                                {item.question}
                            </Typography>
                            <IconButton>
                                {expandedIndex === index ? <CloseIcon sx={{ color: 'black' }} /> : <AddIcon sx={{ color: 'black' }} />}
                            </IconButton>
                        </Box>
                        <Collapse in={expandedIndex === index}>
                            <Box className="faq-answer">
                                <Typography variant="body1" component="p">
                                    {item.answer}
                                </Typography>
                                {item.bulletPoints && (
                                    <List className="faq-bullets">
                                        {item.bulletPoints.map((point, i) => (
                                            <ListItem key={i} className="faq-bullet-point">
                                                <Typography variant="body1" component="span">
                                                    * {point}
                                                </Typography>
                                            </ListItem>
                                        ))}
                                    </List>
                                )}
                                {item.additionalText && (
                                    <Typography variant="body1" component="p">
                                        {item.additionalText}
                                    </Typography>
                                )}
                            </Box>
                        </Collapse>
                    </Box>
                ))}
            </Container>
        </Box>
    );
};

export default SeventhSection;
